// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1rk5F","title":"AfterBackImages_title__s13bu","images":"AfterBackImages_images__1sqaU"};